import { render, staticRenderFns } from "./BuyCredit.vue?vue&type=template&id=13a756be"
import script from "./BuyCredit.vue?vue&type=script&lang=js"
export * from "./BuyCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports